/**
 * Converts a string to a URL-safe ASCII slug.
 * Removes diacritics, lowercases, replaces spaces/special chars with hyphens.
 */
export function slugify(text: string): string {
  return text
    .normalize('NFD') // decomposes accented chars into base + diacritic
    .replace(/[\u0300-\u036f]/g, '') // strip diacritics
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // keep only alphanumeric, spaces, hyphens
    .trim()
    .replace(/[\s]+/g, '-') // spaces to hyphens
    .replace(/-{2,}/g, '-'); // collapse consecutive hyphens
}
